<template>
  <div class="p-5"> 
    <aron-table uploadEndpoint="/uploadFile" :endPoint="route" :filterEndpoint="filterEndpoint" :key="route" :formType="formType"></aron-table>
  </div>
</template>
 
<script>
import AronTable from "../../components/aron/table/tblmain.vue";
export default {
  components: {
    AronTable
  },
  watch:{
    '$route'(to, from){
      this.route = to.params.endPoint
       this.formType = "sidebarRightSide"
    }
  },
  computed:{
      filterEndpoint(){
        return "search_" + this.route;
      }
  },
  data() {
    return { route: this.$route.params.endPoint, formType: "sidebarRightSide" };
  }
};
</script>